(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("userGroupsService", ['$ihttp', function ($ihttp) {
        let service = {
            listUserGroups: function (parms) {
                return $ihttp.post({
                    method: 98,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
